import { schema } from "normalizr";
import { Media as Record } from "records/media";

export const MediaSchema = new schema.Entity("media");

(MediaSchema as any).record = Record;
